var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPricematch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.085 0h-8.17L0 5.264v14.848h14V5.264zM7.162 3.859c-.63 0-1.134-.498-1.134-1.12s.504-1.12 1.134-1.12 1.134.497 1.134 1.12c0 .604-.504 1.12-1.134 1.12"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.787 10.705h-9.25v1.565h9.25zm0 3.556h-9.25v1.565h9.25z"
})));
export default SvgPricematch;